module.exports = __webpack_public_path__ + "img/3.b8795e01.jpg";